import React, { FC } from 'react';
import { Modal } from 'antd';
import { IBookingEvent } from '@types';
import * as S from './styles';

type ModalInfoProps = {
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    bookingData: IBookingEvent | null;
};

export const InfoModal: FC<ModalInfoProps> = ({
    isModalOpen,
    setIsModalOpen,
    bookingData,
}) => {
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Modal
            title={`${bookingData?.hallName}, Стол ${bookingData?.tableName}`}
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
        >
            <S.StyledLabel>
                ID бронирования: <S.StyledSpan>{bookingData?.id}</S.StyledSpan>
            </S.StyledLabel>
            <S.StyledLabel>
                Клиент: <S.StyledSpan>{bookingData?.personName}</S.StyledSpan>
            </S.StyledLabel>
            <S.StyledLabel>
                тел: <S.StyledSpan>{bookingData?.personPhone}</S.StyledSpan>
            </S.StyledLabel>
            <S.StyledLabel>
                Внесенный депозит:{' '}
                <S.StyledSpan>{bookingData?.prePaid}</S.StyledSpan>
            </S.StyledLabel>
            <S.StyledLabel>
                Статус: <S.StyledSpan>Подтверждено</S.StyledSpan>
            </S.StyledLabel>
        </Modal>
    );
};
